import { Row, Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import PropTypes from 'prop-types';
import Figure from './Figure';
import BlockContent from '../BlockContent';

const StyledRowMobileScreenshot = styled(Row)`
  padding-top: 2rem;

  div > figure {
    // this is to override margin-bottom:1.66rem; that comes from layouts
    margin-bottom: 0;
  }
`;

const StyledRowDesktopScreenshot = styled(Row)`
  padding-top: 2rem;
  ${breakpoint('sm')`
    padding-top: 4rem;
  `}
  img {
    // !important is needed to override the default img style
    box-shadow: 0 18px 40px -18px rgba(0, 0, 0, 0.41) !important;
  }
`;

const StyledCaptionMobileScreenshot = styled.figcaption`
  margin-left: 1rem;
  h2 {
    margin-top: 2rem;
  }
  ${breakpoint('sm')`
    margin-top: 5rem;
  `}
`;

const StyledCaptionDesktopScreenshot = styled.figcaption`
  h2 {
    margin-top: 2rem;
  }
`;

const SideBySide = ({ image, title, content, imageAlign }) => {
  if (!imageAlign) {
    return null;
  }
  if (imageAlign.includes('RIGHT') || imageAlign.includes('LEFT')) {
    return (
      <MobileScreenshotSection image={image} title={title} content={content} reverse={imageAlign.includes('RIGHT')} />
    );
  } else {
    return <DesktopScreenshotSection image={image} title={title} content={content} />;
  }
};

SideBySide.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  content: PropTypes.array,
  imageAlign: PropTypes.array,
};

export default SideBySide;

const MobileScreenshotSection = ({ image, title, content, reverse }) => {
  return (
    <StyledRowMobileScreenshot reverse={reverse} between="xs">
      <Col xs={12} sm={4} md={4} lg={4}>
        <Figure {...image} />
      </Col>

      <Col xs={12} sm={8} md={8} lg={8}>
        <StyledCaptionMobileScreenshot>
          <h2>{title}</h2>
          <BlockContent content={content} />
        </StyledCaptionMobileScreenshot>
      </Col>
    </StyledRowMobileScreenshot>
  );
};

MobileScreenshotSection.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  content: PropTypes.array,
  reverse: PropTypes.bool,
};

const DesktopScreenshotSection = ({ image, title, content }) => {
  return (
    <StyledRowDesktopScreenshot>
      <Col xs={12} sm={9}>
        <Figure {...image} />
        <StyledCaptionDesktopScreenshot>
          <h2>{title}</h2>
          <BlockContent content={content} />
        </StyledCaptionDesktopScreenshot>
      </Col>
    </StyledRowDesktopScreenshot>
  );
};

DesktopScreenshotSection.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  content: PropTypes.array,
};
